// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__78QTl","content":"Consent_content__2dlkL","footer":"Consent_footer__2Cgms"};